import type { TrainingModule } from "../types";
import { mountOrdersReaderPreflight } from "./preflight-ui";

export const ordersReaderModule: TrainingModule = {
  id: "orders-reader",
  title: "Orders Reader",
  featureFlag: "ordersReaderModule",
  render: () => ({
    kind: "content",
    heading: "Orders Reader",
    body: "Load the three files of one serial from this device: the warning order, the orders card and the trace image. Nothing is uploaded.",
    mount: mountOrdersReaderPreflight,
  }),
};
